import {useContext} from 'react';
import {DNDContext} from './DNDContext';

export const useDNDContext = () => useContext(DNDContext);
